/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {AboutComponent} from './about.component';

@NgModule({
    declarations: [AboutComponent]
})
export class AboutModule {
}
